/**
 * Stem wall — a TYPE-ONLY family (FOOTINGS round, 2026-08-09; docs/MODELER.md "WALL
 * FOOTINGS + STEM WALLS"): the curated stem-wall section a WALL references via its
 * `stemTypeId` instance param. Like `footing`, no element ever exists in this
 * category — the wall's generator derives the stem prisms, laterally placed by THE
 * alignment rule (stem OUTSIDE face flush with the wall's OUTSIDE core face) and
 * vertically by the wall's stemMode (manual height / topo coverage).
 *
 * STEM FINISH LAYERS round (2026-08-17, Matt: "make sure all per-layer finish
 * rendering related to stems is resolved"): `widthFt`/`material` stay exactly as
 * they were — every stem type in a live model has neither an assembly nor a
 * reason to gain one automatically, so this is a pure additive opt-in, never a
 * migration. `usesAssembly: 'stem'` only means a stem TYPE *may* carry an
 * `assemblyId` (the same generic wall/floor/roof/ceiling assembly record —
 * `createAssembly`/`setTypeAssembly` in commands/library.ts, no stem-specific
 * kernel command needed); `widthFt`/`material` remain the type's own params and
 * still govern its section for any stem type that never acquires one.
 * `wallFoundationSolids` (bim-geometry) checks the RESOLVED stem type's own
 * `assemblyId` at generation time: present → emit one solid per layer (real
 * core+finish bands, `assemblyThicknessFt` replaces `widthFt` as the true
 * section width); absent → today's single flat-material prism, byte-identical
 * to before this round.
 */
import type { CategorySchema } from '../../registry'

export const stemSchema: CategorySchema = {
  id: 'stem',
  label: 'Stem Wall',
  usesAssembly: 'stem',
  typeParams: {
    groups: [
      {
        label: 'Section',
        params: [
          { key: 'widthFt', label: 'Width', kind: 'length', default: 8 / 12, min: 0.25, max: 4 },
          { key: 'material', label: 'Material', kind: 'material', default: '' },
        ],
      },
    ],
  },
  instanceParams: { groups: [] },
}
